import { Card, CardContent, CardHeader } from "@mui/material";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useSalesByFair } from "../../services/useSalesByFair";
import { FC } from "react";

interface Props {
  start_date: string;
  end_date: string;
}

const SalesByFairChart: FC<Props> = ({ start_date, end_date }) => {
  const { data = [], isLoading } = useSalesByFair({ start_date, end_date });

  return (
    <Card sx={{ height: 400 }}>
      <CardHeader title="Faturamento bruto por feira" />
      <CardContent sx={{ height: "320px" }}>
        {isLoading ? (
          "Carregando..."
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="fair__delivery_at" />
              <YAxis dataKey={(row) => Number(row.total_gross)} />
              <Tooltip
                formatter={(v: string) => `R$ ${Number(v).toFixed(2)}`}
              />
              <Bar
                dataKey={(row) => Number(row.total_gross)}
                name="Faturamento (R$)"
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default SalesByFairChart;
